import ReactDOM from "react-dom";

const SCContextMenuPortal = ({ children }) => {
  const el = document.getElementById("se_sc_context_menu");
  if (el) {
    return ReactDOM.createPortal(children, el);
  } else {
    return null;
  }
  return ReactDOM.createPortal(children, el);
};

export default SCContextMenuPortal;
